import Slider from '../services/sliderService';

export default function gallerySlider() {
    const elements = document.querySelectorAll('.js-gallery-slider');

    elements.forEach((element) => {
        const wrapper = element.closest('.gallery-slider');

        const options = {
            slidesPerView: 1,
            spaceBetween: 0,
            zoom: {
                maxRatio: 3,
                toggle: true,
            },
            pagination: {
                el: wrapper.querySelector('.js-gallery-slider-pagination'),
                type: 'fraction',
            },
            navigation: {
                prevEl: wrapper.querySelector('.js-gallery-slider-previous'),
                nextEl: wrapper.querySelector('.js-gallery-slider-next'),
            },
            on: {
                zoomChange(swiper, scale) {
                    const zoomed = scale > 1;
                    const instance = swiper;

                    instance.allowTouchMove = !zoomed;
                    instance.allowSlideNext = !zoomed;
                    instance.allowSlidePrev = !zoomed;

                    wrapper.classList.toggle('gallery-slider--zoomed', zoomed);
                },
            },
        };

        // eslint-disable-next-line no-new
        new Slider(element, options);
    });
}
